<!-- eslint-disable vue/no-v-html -->
<template>

  <div>
    {{ time }}
  </div>
</template>

<script>
import { mapState } from 'vuex'
import request from '@/utils/request'
import OnEvent from '../common/OnEvent.vue'
import moment from 'moment'
import _ from 'lodash'
export default {
  extends: OnEvent,
  props: {
    propValue: {
      type: String,
      required: true,
      default: ''
    },
    request: {
      type: Object,
      default: () => {}
    },
    element: {
      type: Object,
      default: () => {}
    },
    linkage: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      canEdit: false,
      ctrlKey: 17,
      isCtrlDown: false,
      cancelRequest: null,
      time: moment().format('HH:mm:ss')
    }
  },
  computed: {
    ...mapState({
      editMode: state => state.compose.editMode,
      curComponent: state => state.compose.curComponent
    })
  },
  watch: {
    element: {
      immediate: true,
      deep: true,
      handler(e) {
        this.setTime()
      }
    }
  },
  created() {
    this.setTime = _.debounce(this.setTime, 100)
    // 注意，修改时接口属性时不会发数据，在预览时才会发
    // 如果要在修改接口属性的同时发请求，需要 watch 一下 request 的属性
    if (this.request) {
      // 第二个参数是要修改数据的父对象，第三个参数是修改数据的 key，第四个数据修改数据的类型
      this.cancelRequest = request(this.request, this.element, 'propValue', 'string')
    }
  },
  beforeDestroy() {
    // 组件销毁时取消请求
    this.request && this.cancelRequest()
  },
  methods: {
    setTime() {
      let date = `${this.element.style.year}-${this.element.style.month}-${this.element.style.day} ${this.element.style.hour}:${this.element.style.minute}:${this.element.style.second}`
      if (this.element.style.year === 0) {
        date = moment().format('YYYY-MM-DD HH:mm:ss')
      }
      if (this.element.style.format === 0) {
        this.time = moment(date).format('HH:mm:ss')
      } else if (this.element.style.format === 1) {
        this.time = moment(date).format('HH:mm')
      } else {
        this.time = moment(date).format('mm:ss')
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
